import { Modal } from "react-bootstrap";
import plusIcon from "../../../../images/plus-solid.png";
import minusIcon from "../../../../images/minus-solid.png";
import placeholderImage from "../../../../images/placeholder-image.png";
import ModifierCategoryModal from "./ModifierCategoryModal.js";
import ProductComboGroup from "./ProductComboGroup.js";
import ErrorAlert from "../../../../common/ui/ErrorAlert.js";
import * as CommonUtilities from "../../../../common/utils/CommonUtils.js"

export default function ProductDetailsModalPage(props) { 
    let instrIsInvalid = "";
    if (props.productFormData.validation.SpecialInstructions.HasError) {
        instrIsInvalid = "is-invalid";
    } else {
        instrIsInvalid = "";
    }

    let energyCount;
    if (props.productDetails.energyCount !== 0 && props.productDetails.energyCount !== "0" && props.productDetails.energyCount !== "" && props.productDetails.energyCount !== null) {
        energyCount = <span className="badge bg-secondary bg-opacity-50">{props.productDetails.energyCount}kJ</span>
    } else {
        energyCount = <></>
    }
    let specialInstructions, titleSpecialInstructions, charLengthSpecialInstructions;
    if (props.productFormData.config.SpecialInstructions.IsShownMod) {
        titleSpecialInstructions = props.productFormData.config.SpecialInstructions.Title;
        charLengthSpecialInstructions = props.productFormData.config.SpecialInstructions.CharacterLength;
    } else if (props.productFormData.config.SpecialInstructions.IsShownProduct) {
        titleSpecialInstructions = props.productFormData.config.ProductSpecialInstructions.ProductTitle;
        charLengthSpecialInstructions = props.productFormData.config.ProductSpecialInstructions.ProductCharacterLength;
    }

    // === begin: Bulk Pricing ===
    let priceRangeCard;
    if (CommonUtilities.StaticFields.PriceType == 'bp8826') {
        if (props.productDetails.bulkPricingProductsPriceList.length > 0) {
            let qtyRange = props.productDetails.bulkPricingProductsPriceList.map((item, index) => {
                return <small key={index}>{item.qtyStartRange}{item.qtyEndRange == 9999 ? '+' : ' - ' + item.qtyEndRange}</small>
            });
            let bulkPrices = props.productDetails.bulkPricingProductsPriceList.map((item, index) => {
                return <small key={index}>{CommonUtilities.StaticFields.CurrencySymbol}{(item.priceInc).toFixed(2)} each</small>
            })
            priceRangeCard = <div className="bg-secondary-subtle py-1 px-3 mt-3 rounded d-flex flex-column gap-2" style={{maxWidth: "170px"}}>
                                    <div className="d-flex flex-row justify-content-between gap-4">
                                        <div className="d-flex flex-column">
                                            {qtyRange}
                                        </div>
                                        <div className="d-flex flex-column">
                                            {bulkPrices}
                                        </div>
                                    </div>
                                    <small className="text-center text-muted"><i>Discount will be applied in cart</i></small>
                                </div>
        } else {
            priceRangeCard = <></>;
        }
    }
    // === end: Bulk Pricing ===

    // Regular or Combo Product
    let modifierCategories, hrSeparation;
    if (props.productDetails.itemUsageTypeName === "Regular") { // ItemUsageTypeID = 1 (Regular Product)
        hrSeparation = <></>
        modifierCategories = props.productDetails.modCategories?.map((item) => {
            return (
                <ModifierCategoryModal 
                key={item.modCategoryId} 
                modifierCategoryDetails={item} 
                handleModFormChange={props.handleModFormChange} 
                handleModifierComboSelect={props.handleModifierComboSelect}
                handleRemoveModifierComboFromProduct={props.handleRemoveModifierComboFromProduct}
                productFormDataMods={props.productFormData.data.Mods} // Passing as productFormDataMods
                productFormDataModCatValidation={props.productFormData.validation.ModCategories} // Passing as productFormDataModCatValidation
                addToCartError={props.addToCartError}
                currentLocation={props.currentLocation}
                priceInc={props.productDetails.priceInc}
                />
            )
        })

        // Special Instructions
        if (props.productFormData.config.SpecialInstructions.IsShownProduct || props.productFormData.config.SpecialInstructions.IsShownMod) {
            specialInstructions = <div className="col-12 justify-content-center mx-auto form-floating mb-3">
                                    <textarea className={`form-control ${instrIsInvalid}`} id="txtareaSpecialInstr" name="SpecialInstructions" value={props.productFormData.data.SpecialInstructions} onChange={props.handleProductFormChange} disabled={props.addToCartError.ButtonsDisabled} maxLength={charLengthSpecialInstructions}></textarea>
                                    <label htmlFor="txtareaSpecialInstr">{titleSpecialInstructions}{` (max ${charLengthSpecialInstructions} characters)`}</label>
                                    <small className="invalid-feedback">{props.productFormData.validation.SpecialInstructions.ErrorMessage}</small>
                                </div>
        } else {
            specialInstructions = <></>
        }

        // // ============ begin: PREV ================
        
        // if (!props.productDetails.hideSpecialInstruction) {
        //     let title = "";
        //     if (props.productDetails.specialInstructionTitle !== '' && props.productDetails.specialInstructionTitle !== null) {
        //         title = props.productDetails.specialInstructionTitle;
        //     }
        //     specialInstructions = <div className="col-12 justify-content-center mx-auto form-floating mb-3">
        //                             <textarea className={`form-control ${instrIsInvalid}`} id="txtareaSpecialInstr" name="SpecialInstructions" value={props.productFormData.data.SpecialInstructions} onChange={props.handleProductFormChange} disabled={props.addToCartError.ButtonsDisabled} maxLength={props.productDetails.specialInstructionMaxLength}></textarea>
        //                             <label htmlFor="txtareaSpecialInstr">{title}</label>
        //                             <small className="invalid-feedback">{props.productFormData.validation.SpecialInstructions.ErrorMessage}</small>
        //                         </div>
        // } else {
        //     specialInstructions = <></>
        // }
        // // ============ end: PREV ================
        

    } else if (props.productDetails.itemUsageTypeName === "Combo") { // ItemUsageTypeID = 2 (Product Combo)
        if (CommonUtilities.StaticFields.PriceType == 'bp8826') {
            // Bulk Pricing
            hrSeparation = <div className="col-12">
                                <hr className="text-body-tertiary"/>
                            </div>
        } else {
            hrSeparation = <></>
        }
        modifierCategories = props.productDetails.comboGroups?.map((item) => {
            // Find group form data for this product group
            let groupFormData = props.productFormData.data.ProductsInCombo.find((groupItem) => groupItem.productComboGroupID == item.productComboGroupID);
            let groupValidationData = props.productFormData.validation.ProductComboGroups.find((groupValidation) => groupValidation.ProductComboGroupID == item.productComboGroupID);
            
            return (
                <ProductComboGroup
                    key={item.productComboGroupID}
                    productComboGroupDetails={item}
                    groupFormData={groupFormData} // productFormData being passed just for groupFormData
                    groupValidationData={groupValidationData}
                    plusIcon={plusIcon}
                    handleProductComboGroupSelect={props.handleProductComboGroupSelect}
                    addToCartError={props.addToCartError}
                />
            )
        })
        specialInstructions = <></>
    }

    return (
        <>
            <Modal.Body>
                <div className="row">
                    <div className="col-4">
                        <img src={props.productDetails.productImageURL ? props.productDetails.productImageURL : placeholderImage} className="rounded-3 float-end my-2 w-100 shadow-sm" style={{objectFit: "cover", objectPosition: "center center", aspectRatio: "1/1", maxWidth: "300px", minWidth: "70px"}} alt="Product"></img>
                    </div>
                    <div className="col-8 d-flex flex-column justify-content-between">
                        <div className="d-flex flex-column text-break">
                            <div>
                                <b className="me-2">{props.productDetails.productName}</b>{energyCount}
                            </div>
                            {props.productDetails.productDescription && <span>{props.productDetails.productDescription}</span>}
                        </div>
                        <div className="d-flex flex-sm-row flex-column justify-content-between align-items-sm-end">
                            <b className="mt-3">${props.productDetails.priceInc && props.productDetails.priceInc.toFixed(2)}</b>
                            {priceRangeCard}
                        </div>
                    </div>
                    {hrSeparation}
                    {modifierCategories}                        
                </div>
            </Modal.Body>
            <Modal.Footer>
                { props.currentLocation.AllowOnlineOrder && props.currentLocation.Validation.IsValidTableNumber && !props.productDetails.isSoldOut && 
                specialInstructions}
                { props.currentLocation.AllowOnlineOrder && props.currentLocation.Validation.IsValidTableNumber && !props.productDetails.isSoldOut && 
                <div className="col-12 d-flex flex-column justify-content-center mx-auto gap-2 align-items-center mb-3">
                    <div className="d-flex flex-row justify-content-center mx-auto gap-3 align-items-center">
                        <button type="button" className="btn btn-dark rounded-pill d-flex align-items-center justify-content-center" onClick={props.handleProductFormSubtractQuantity} disabled={props.addToCartError.ButtonsDisabled} style={{height: "34px", width: "34px"}}>
                            <img src={minusIcon} alt="Remove" style={{width: "16px"}}></img>
                        </button>
                        <span>{props.productFormData.data.Quantity}</span>
                        <button type="button" className="btn btn-dark rounded-pill d-flex align-items-center justify-content-center" onClick={props.handleProductFormAddQuantity} disabled={props.addToCartError.ButtonsDisabled} style={{height: "34px", width: "34px"}}>
                            <img src={plusIcon} alt="Add" style={{width: "16px"}}></img>
                        </button>
                    </div>
                    {props.productFormData.validation.Quantity.HasError && <small className="text-danger">{props.productFormData.validation.Quantity.ErrorMessage}</small>}
                </div>}
                { props.addToCartError.HasError && <div className="px-1 mx-auto mb-3 col-12"><ErrorAlert message={props.addToCartError.ErrorMessage} /></div> }
                { props.currentLocation.AllowOnlineOrder && props.currentLocation.Validation.IsValidTableNumber && !props.productDetails.isSoldOut && 
                <div className="col-12 d-flex justify-content-center mx-auto">
                    <button type="button" className="btn btn-dark rounded-pill px-5" onClick={props.handleAddProductToCart} disabled={props.addToCartError.ButtonsDisabled}>
                        Add to Cart
                        {props.addToCartError.ButtonsDisabled && <>&ensp;<span className="spinner-border spinner-border-sm" aria-hidden="true"></span></>}
                    </button>
                </div>
            }
            </Modal.Footer>
        </>
    )
}